import { ApolloLink, Observable } from '@apollo/client/core';
import { MaintenanceService } from './maintenance.service';
export function maintenanceGate(maintenance: MaintenanceService): ApolloLink {
  return new ApolloLink((operation, forward) =>
    maintenance.blocked() ? new Observable((observer) => observer.error(new Error('MAINTENANCE'))) : forward(operation)
  );
}
export function maintenanceFetch(maintenance: MaintenanceService): typeof fetch {
  return async (input, init) => {
    if (maintenance.blocked()) {
      throw new Error('MAINTENANCE');
    }
    try {
      const response = await fetch(input, init);
      if (!response.ok) {
        maintenance.reportFailure(
          response.status,
          await response
            .clone()
            .json()
            .catch(() => null)
        );
      }
      return response;
    } catch (error) {
      if (!maintenance.blocked()) {
        maintenance.reportFailure(0, null);
      }
      throw error;
    }
  };
}
